import React from 'react';
import PropTypes from 'prop-types';
import { ProductCard } from '../../molecules';
import { toggleItem } from '../../toggle';
import { ProductSelectionContainer, ProductCardWrapper } from './styles.js';

export const ProductSelector = ({
  products,
  unavailableProducts = [],
  selected = [],
  onChange,
  onDetailsClick,
  variant = 'checkbox',
}) => {
  const handleChange = (selected, product) => {
    variant === 'checkbox'
      ? onChange?.(toggleItem(selected, product))
      : !selected.includes(product) && onChange?.([product]);
  };

  return (
    <ProductSelectionContainer>
      {products.map(product => {
        return (
          <ProductCardWrapper key={product.value}>
            <ProductCard
              {...product}
              unavailable={unavailableProducts.includes(product.value)}
              unavailableText={product.unavailableText}
              onDetailsClick={() => onDetailsClick(product)}
              onChange={e => handleChange(selected, product.value)}
              checked={selected.includes(product.value)}
              inputType={variant}
              callout={product.callout}
            />
          </ProductCardWrapper>
        );
      })}
    </ProductSelectionContainer>
  );
};

ProductSelector.displayName = 'ProductSelector';
ProductSelector.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ),
  unavailableProducts: PropTypes.arrayOf(PropTypes.string),
  selected: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  onDetailsClick: PropTypes.func,
  variant: PropTypes.oneOf(['checkbox', 'radio']),
};
